




import { Component, Vue, Prop } from 'vue-property-decorator';
import { Company } from '../../models/company/companyprofile';
import { vxm } from '../../store.vuex';

@Component({
  name: 'OrganizationJsonLD',
})
export default class OrganizationJsonLD extends Vue {
  @Prop() CompanyInfo!: Company;

  jsonldContent() {
    if (!this.CompanyInfo) return {};
    return {
      '@context': 'https://schema.org/',
      '@type': 'Organization',
      name: this.CompanyInfo.companyName,
      url: this.CompanyInfo.companyUrl || '',
      address: {
        '@type': 'PostalAddress',
        streetAddress: vxm.configs.getGlobalConfigValue('STREET_ADDRESS') || '',
        addressLocality:
          vxm.configs.getGlobalConfigValue('ADDRESS_LOCATION') || '',
        addressRegion: vxm.configs.getGlobalConfigValue('ADDRESS_REGION') || '',
        postalCode: vxm.configs.getGlobalConfigValue('POSTAL_CODE') || '',
        addressCountry:
          vxm.configs.getGlobalConfigValue('ADDRESS_COUNTRY') || '',
      },
    };
  }
}
